import React from "react";

import { VisibilityOffRounded, VisibilityRounded } from "@mui/icons-material";
import LoginRoundedIcon from "@mui/icons-material/LoginRounded";
import { Box } from "@mui/material";

import useAuth from "../../../config/context/authContext";
import useModal from "../../../config/context/modalContext";
import storageKey from "../../../config/storageKey";
import { GreyPallet } from "../../../config/styles";

import MainLinkButton from "../../../components/MainLinkButton";
import MainSolidButton from "../../../components/MainSolidButton";
import MainText from "../../../components/MainText";

import { AvailableFormOptions } from "..";
import TextMain from "../../../components/InputMain/TextMain";
import MainSubmit from "../../../components/MainSubmit";
import { Dev } from "../../../config/util/consoleUtil";

interface ComponentProps {
  setFormOption: (option: AvailableFormOptions) => void;
}

export default function SigninForm({ setFormOption }: ComponentProps) {
  const { authEmailLogInSend, authEmailLogInConfirm, authSignUpUser } = useAuth();
  const { pushAlert } = useModal();

  const loggedIn = false;
  const checkedEmail = false;

  const [onLoginProcess, setOnLoginProcess] = React.useState<string | null>(
    window.localStorage.getItem(storageKey.TMP_EMAIL)
  );

  const [loading, setLoading] = React.useState(false);

  const [emailField, setEmailField] = React.useState("");
  const [passwordField, setPasswordField] = React.useState("");
  const [passwordConfirmField, setPasswordConfirmField] = React.useState("");

  const [showPassword, setShowPassword] = React.useState(false);

  const handleSignup = async () => {
    try {
      if (passwordConfirmField !== passwordField) {
        pushAlert({
          type: "error",
          message: "As senhas não estão iguais",
        });
        return;
      }

      setLoading(true);
      await authSignUpUser(emailField, passwordField);
    } catch (error) {
      console.log(...new Dev("handleSignup", error).Error());
      pushAlert({
        type: "error",
        message: "Erro ao cadastrar usuário",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 2 }} style={{ backgroundColor: GreyPallet.Light, borderRadius: 15 }}>
      <MainText color="regular">
        Por segurança, para utilizar todas as funcionalidades do aplicativo é necessário fazer login
        com seu email.
      </MainText>

      <Box mt={3}>
        <MainText color="regular">
          Não se procupe, seu email não ficará visível para outros usuários.
        </MainText>
      </Box>

      <Box mt={2}>
        <TextMain
          name="Email"
          value={emailField}
          onChange={setEmailField}
          borderColor={"regular"}
          textColor={"regular"}
          inputType="email"
          inputMode="email"
        />

        <TextMain
          name="Senha"
          value={passwordField}
          onChange={setPasswordField}
          borderColor={"regular"}
          textColor={"regular"}
          inputType={showPassword ? "text" : "password"}
          adornmentIcon={showPassword ? <VisibilityRounded /> : <VisibilityOffRounded />}
          adornmentClick={() => setShowPassword(!showPassword)}
        />

        <MainSubmit onSubmit={handleSignup}>
          <TextMain
            name="Confirmar Senha"
            value={passwordConfirmField}
            onChange={setPasswordConfirmField}
            borderColor={"regular"}
            textColor={"regular"}
            inputType={"password"}
          />
        </MainSubmit>

        <MainSolidButton
          disabled={passwordConfirmField !== passwordField || passwordField.length < 6}
          loading={loading}
          text="Criar Conta"
          icon={<LoginRoundedIcon />}
          onClick={handleSignup}
        />
      </Box>

      <Box mt={2}>
        <MainLinkButton
          text="Já possuo uma conta"
          onClick={() => setFormOption(AvailableFormOptions.login)}
        />
      </Box>
    </Box>
  );
}
